import { __decorate, __metadata, __param } from "tslib";
import { elementDefine, onConnectedBodyShadow, onConnectedAfter, onInitialize, onDisconnected, event, eventDelegate, innerHtml, onConnectedBefore, attribute } from "@dooboostore/simple-web-component";
import { Router } from '@dooboostore/core-web';
import { Inject } from '@dooboostore/simple-boot';
import { VideoItemService } from '../../services/english/VideoItemService';
import { TextTranslationService } from '../../services/english/TextTranslationService';
import { DictionaryService } from '../../services/english/DictionaryService';
import { VoiceService } from '../../services/english/VoiceService';
const tagName = 'center-text-english-reader-page';
export default (w) => {
    var _a, _b, _c, _d, _e, _f;
    const existing = w.customElements.get(tagName);
    if (existing)
        return tagName;
    let TextEnglishReaderPage = class TextEnglishReaderPage extends w.HTMLElement {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "router", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "docName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "entries", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "currentActiveIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: -1
            });
            Object.defineProperty(this, "currentWordIndex", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: -1
            });
            Object.defineProperty(this, "currentSelectedWord", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ""
            });
            Object.defineProperty(this, "soundEnabled", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: true
            });
            Object.defineProperty(this, "showKorean", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "videoItemService", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "textTranslationService", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "dictionaryService", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "voiceService", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        setPageMeta() {
            return {
                titleBody: "Text Reader | @dooboostore",
                ogTitle: "Text Reader | @dooboostore",
                desc: "텍스트를 읽으며 영어를 배우세요. 단어 클릭으로 툴팁 사전·발음 듣기.",
                ogDesc: "텍스트를 읽으며 영어를 배우세요. 단어 클릭으로 툴팁 사전·발음 듣기.",
                ogImage: "/assets/images/text-english-og.png",
                twitterImage: "/assets/images/text-english-og.png",
                twitterTitle: "Text Reader | @dooboostore",
                twitterDesc: "텍스트를 읽으며 영어를 배우세요. 단어 클릭으로 툴팁 사전·발음 듣기.",
            };
        }
        onInit(videoItemService, textTranslationService, dictionaryService, voiceService) {
            this.videoItemService = videoItemService;
            this.textTranslationService = textTranslationService;
            this.dictionaryService = dictionaryService;
            this.voiceService = voiceService;
        }
        async onConnectedAfter(router) {
            this.router = router;
            const name = this.getAttribute("name");
            if (!name) {
                console.error("No document name provided");
                return;
            }
            this.docName = decodeURIComponent(name);
            try {
                const headerTitle = this.shadowRoot?.querySelector(".header-title");
                if (headerTitle)
                    headerTitle.textContent = `📖 ${this.docName}`;
                this.entries = await this.textTranslationService.entries(this.docName);
                if (this.entries.length > 0) {
                    this.currentActiveIndex = 0;
                }
                this.renderSentences();
                this.updateToolbar();
                this.setupKeyboardListeners();
                this.scrollToActiveItem(false);
            }
            catch (e) {
                console.error("Failed to load text", e);
                this.renderSentences();
            }
        }
        onDisconnected() {
            this.removeKeyboardListeners();
            this.voiceService?.stopSpeech();
            this.closePopup();
        }
        setupKeyboardListeners() {
            const handleKeydown = (e) => {
                // 팝업 안의 입력/포커스에서는 전역 단축키 무시 (단 Esc는 닫기)
                const inPopup = e.target?.closest?.(".word-popup");
                if (e.key === "Escape") {
                    this.closePopup();
                    return;
                }
                if (inPopup)
                    return;
                if (e.key === "ArrowDown") {
                    e.preventDefault();
                    this.goSentence(1);
                }
                else if (e.key === "ArrowUp") {
                    e.preventDefault();
                    this.goSentence(-1);
                }
                else if (e.key === "ArrowRight") {
                    e.preventDefault();
                    this.onNextWord();
                }
                else if (e.key === "ArrowLeft") {
                    e.preventDefault();
                    this.onPrevWord();
                }
                else if (e.key === "Enter") {
                    e.preventDefault();
                    this.speakActiveSentence();
                }
                else if (e.key === " " && (e.target === w.document.body || e.target?.closest?.(".reading-toolbar"))) {
                    e.preventDefault();
                    this.speakActiveSentence();
                }
                else if (e.key === "t" || e.key === "T") {
                    e.preventDefault();
                    this.onKoreanToggle();
                }
                else if (e.key === "m" || e.key === "M") {
                    e.preventDefault();
                    this.onSoundToggle();
                }
            };
            w.document.addEventListener("keydown", handleKeydown);
            this._keydownHandler = handleKeydown;
        }
        removeKeyboardListeners() {
            const handler = this._keydownHandler;
            if (handler) {
                w.document.removeEventListener("keydown", handler);
                this._keydownHandler = null;
            }
        }
        escapeHtml(text) {
            const map = {
                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
            };
            return text.replace(/[&<>"']/g, (char) => map[char]);
        }
        renderSentenceWords(text, itemIndex) {
            const words = text.split(/(\s+)/);
            let nonWhitespaceIndex = 0;
            return words
                .map((word) => {
                if (/^\s+$/.test(word))
                    return word;
                const cleanWord = word.replace(/[,.":!?;()]/g, "").toLowerCase();
                const idx = nonWhitespaceIndex;
                nonWhitespaceIndex++;
                if (!cleanWord)
                    return this.escapeHtml(word);
                return `<span class="word" data-word="${cleanWord}" data-item-index="${itemIndex}" data-word-index="${idx}" role="button" tabindex="0" aria-label="${cleanWord} 뜻 보기">${this.escapeHtml(word)}</span>`;
            })
                .join("");
        }
        renderSentences() {
            if (!this.entries.length) {
                return '<div class="empty">본문을 불러오는 중...</div>';
            }
            return this.entries
                .map((entry, idx) => `
          <div class="sentence${idx === this.currentActiveIndex ? " active" : ""}" data-index="${idx}" tabindex="-1">
            <p class="en">${this.renderSentenceWords(entry.en, idx)}</p>
            ${this.showKorean && entry.ko ? `<p class="ko">${this.escapeHtml(entry.ko)}</p>` : ""}
          </div>
        `)
                .join("");
        }
        updateToolbar() {
            const root = this.shadowRoot;
            if (!root)
                return;
            const progress = root.querySelector(".progress");
            if (progress) {
                progress.textContent = this.entries.length
                    ? `${this.currentActiveIndex + 1} / ${this.entries.length}`
                    : "0 / 0";
            }
            const koBtn = root.querySelector(".btn-korean");
            if (koBtn)
                koBtn.classList.toggle("active", this.showKorean);
            const soundBtn = root.querySelector(".btn-sound");
            if (soundBtn)
                soundBtn.classList.toggle("active", this.soundEnabled);
        }
        goSentence(delta) {
            if (!this.entries.length)
                return;
            const next = Math.min(this.entries.length - 1, Math.max(0, this.currentActiveIndex + delta));
            if (next === this.currentActiveIndex)
                return;
            const prev = this.currentActiveIndex;
            this.currentActiveIndex = next;
            this.currentWordIndex = -1;
            this.currentSelectedWord = "";
            this.closePopup();
            // 전체 리렌더 금지 (1443문장 innerHTML이 느림) — active 클래스만 교체
            this.updateActiveSentence(prev, next);
            this.updateToolbar();
            this.scrollToActiveItem(false);
        }
        /** 전체 리렌더 없이 active 문장만 교체 */
        updateActiveSentence(prevIdx, nextIdx) {
            const root = this.shadowRoot;
            if (!root)
                return;
            if (prevIdx >= 0) {
                root.querySelector(`.sentence[data-index="${prevIdx}"]`)?.classList.remove("active");
            }
            if (nextIdx >= 0) {
                root.querySelector(`.sentence[data-index="${nextIdx}"]`)?.classList.add("active");
            }
        }
        /** 문장의 단어 토큰 (공백 제외, 순서대로) */
        sentenceWords(itemIndex) {
            const entry = this.entries[itemIndex];
            if (!entry)
                return [];
            return entry.en.split(/(\s+)/).filter((part) => !/^\s+$/.test(part));
        }
        cleanToken(token) {
            return token.replace(/[,.":!?;()]/g, "").toLowerCase();
        }
        /** 단어 선택의 단일 진입점 — 클릭/키보드/이전다음 모두 여기로 */
        activateWord(itemIndex, wordIndex) {
            const tokens = this.sentenceWords(itemIndex);
            if (wordIndex < 0 || wordIndex >= tokens.length)
                return;
            const word = this.cleanToken(tokens[wordIndex]);
            if (!word)
                return;
            const sentenceChanged = itemIndex !== this.currentActiveIndex;
            const prevIndex = this.currentActiveIndex;
            this.currentActiveIndex = itemIndex;
            this.currentWordIndex = wordIndex;
            this.currentSelectedWord = word;
            if (sentenceChanged) {
                this.updateActiveSentence(prevIndex, itemIndex);
                this.updateToolbar();
                this.scrollToActiveItem(false);
            }
            else {
                this.highlightSelectedWord();
            }
            if (this.soundEnabled) {
                this.voiceService.speakWord(word);
            }
            const wordEl = this.shadowRoot?.querySelector(`.word[data-item-index="${itemIndex}"][data-word-index="${wordIndex}"]`);
            if (wordEl) {
                const popup = this.openPopupLoading(wordEl, word);
                if (popup)
                    this.fillPopup(popup, wordEl, word);
            }
        }
        highlightSelectedWord() {
            const root = this.shadowRoot;
            if (!root)
                return;
            root.querySelectorAll(".word.selected").forEach((el) => {
                if (!el.closest(".word-popup"))
                    el.classList.remove("selected");
            });
            if (this.currentActiveIndex >= 0 && this.currentWordIndex >= 0) {
                const wordEl = root.querySelector(`.reading .word[data-item-index="${this.currentActiveIndex}"][data-word-index="${this.currentWordIndex}"]`);
                if (wordEl)
                    wordEl.classList.add("selected");
            }
        }
        onPrevWord() {
            if (this.currentActiveIndex < 0) {
                if (this.entries.length)
                    this.activateWord(0, 0);
                return;
            }
            if (this.currentWordIndex > 0) {
                this.activateWord(this.currentActiveIndex, this.currentWordIndex - 1);
                return;
            }
            // 현재 문장 첫 단어 → 이전 문장 마지막 단어 (EnglishPlayer와 동일)
            if (this.currentActiveIndex > 0) {
                const prevTokens = this.sentenceWords(this.currentActiveIndex - 1);
                // 뒤에서부터 발음 가능한 단어 찾기
                for (let i = prevTokens.length - 1; i >= 0; i--) {
                    if (this.cleanToken(prevTokens[i])) {
                        this.activateWord(this.currentActiveIndex - 1, i);
                        return;
                    }
                }
                this.goSentence(-1);
            }
        }
        onNextWord() {
            if (this.currentActiveIndex < 0) {
                if (this.entries.length)
                    this.activateWord(0, 0);
                return;
            }
            const tokens = this.sentenceWords(this.currentActiveIndex);
            if (this.currentWordIndex < tokens.length - 1) {
                for (let i = this.currentWordIndex + 1; i < tokens.length; i++) {
                    if (this.cleanToken(tokens[i])) {
                        this.activateWord(this.currentActiveIndex, i);
                        return;
                    }
                }
            }
            // 현재 문장 마지막 단어 → 다음 문장 첫 단어 (EnglishPlayer와 동일)
            if (this.currentActiveIndex < this.entries.length - 1) {
                const nextTokens = this.sentenceWords(this.currentActiveIndex + 1);
                for (let i = 0; i < nextTokens.length; i++) {
                    if (this.cleanToken(nextTokens[i])) {
                        this.activateWord(this.currentActiveIndex + 1, i);
                        return;
                    }
                }
                this.goSentence(1);
            }
        }
        clearWordSelection() {
            this.currentWordIndex = -1;
            this.currentSelectedWord = "";
            this.highlightSelectedWord();
        }
        scrollToActiveItem(smooth) {
            const active = this.shadowRoot?.querySelector(".sentence.active");
            if (!active)
                return;
            // 포커스를 옮기고 window 스크롤을 따라가게 (안쪽 스크롤 컨테이너 없음)
            active.focus({ preventScroll: true });
            const top = active.getBoundingClientRect().top + w.scrollY - 80;
            w.scrollTo({
                top: Math.max(0, top),
                behavior: smooth ? "smooth" : "auto",
            });
        }
        speakActiveSentence() {
            if (this.currentActiveIndex < 0 || !this.entries[this.currentActiveIndex])
                return;
            if (!this.soundEnabled)
                return;
            this.voiceService.speakScript(this.entries[this.currentActiveIndex].en);
        }
        // ── 단어 툴팁 팝업 ──
        closePopup() {
            const popup = this.shadowRoot?.querySelector(".word-popup");
            if (popup)
                popup.remove();
            const highlighted = this.shadowRoot?.querySelectorAll(".word.selected");
            highlighted?.forEach((el) => el.classList.remove("selected"));
        }
        openPopupLoading(wordEl, word) {
            const reading = this.shadowRoot?.querySelector(".reading");
            if (!reading)
                return null;
            this.closePopup();
            wordEl.classList.add("selected");
            const popup = w.document.createElement("div");
            popup.className = "word-popup";
            popup.innerHTML = `
        <div class="popup-head">
          <strong class="popup-word">${this.escapeHtml(word)}</strong>
          <div class="popup-head-btns">
            <button class="popup-speak" aria-label="발음 듣기" title="발음 듣기">🔊</button>
            <button class="popup-close" aria-label="닫기" title="닫기">✕</button>
          </div>
        </div>
        <div class="popup-body"><div class="popup-loading">사전 불러오는 중...</div></div>
      `;
            // 클릭한 단어 근처에 배치 (.reading 기준, window 스크롤이 메인이라 rect 차이로 계산)
            popup.style.visibility = "hidden";
            reading.appendChild(popup);
            this.positionPopup(popup, wordEl, reading);
            popup.style.visibility = "visible";
            return popup;
        }
        /** 팝업 위치 계산 — 콘텐츠가 채워져 높이가 바뀔 때마다 다시 호출 */
        positionPopup(popup, wordEl, reading) {
            const wordRect = wordEl.getBoundingClientRect();
            const readingRect = reading.getBoundingClientRect();
            const popupWidth = Math.min(300, readingRect.width - 16);
            const popupHeight = popup.offsetHeight || 120;
            let left = wordRect.left - readingRect.left - 20;
            left = Math.max(8, Math.min(left, readingRect.width - popupWidth - 8));
            let top;
            if (wordRect.bottom + popupHeight + 8 > w.innerHeight) {
                // 아래가 잘리면 단어 위로
                top = wordRect.top - readingRect.top - popupHeight - 8;
            }
            else {
                top = wordRect.bottom - readingRect.top + 8;
            }
            popup.style.left = `${left}px`;
            popup.style.top = `${Math.max(8, top)}px`;
        }
        fillPopup(popup, wordEl, word) {
            const body = popup.querySelector(".popup-body");
            if (!body)
                return;
            // 사전 내용이 채워지면 팝업 높이가 바뀌므로 위치 재계산
            const reposition = () => {
                const reading = this.shadowRoot?.querySelector(".reading");
                if (reading && popup.isConnected)
                    this.positionPopup(popup, wordEl, reading);
            };
            this.dictionaryService.getWord(word).then((dict) => {
                if (!popup.isConnected)
                    return;
                if (!dict.items || dict.items.length === 0) {
                    body.innerHTML = `<div class="popup-empty">사전에 없는 단어예요.</div>`;
                }
                else {
                    const item = dict.items[0];
                    const phonetic = item.phoneticSigns?.map((p) => p.sign).filter(Boolean).join(" · ") ?? "";
                    const posHtml = (item.pos ?? [])
                        .slice(0, 3)
                        .map((pos) => {
                        const meanings = (pos.meanings ?? []).slice(0, 2).map((m) => {
                            const ex = (m.examples ?? [])[0];
                            return `<div class="meaning">• ${this.escapeHtml(m.meaning ?? "")}${ex ? `<div class="example-en">“${this.escapeHtml(ex.text ?? "")}”</div>
                        <div class="example-ko">${this.escapeHtml(ex.translatedText ?? "")}</div>` : ""}</div>`;
                        }).join("");
                        return `<div class="pos-block"><div class="pos-type">${this.escapeHtml(pos.type ?? "")}</div>${meanings}</div>`;
                    })
                        .join("");
                    body.innerHTML = `
            ${phonetic ? `<div class="phonetic">[${this.escapeHtml(phonetic)}]</div>` : ""}
            ${posHtml || '<div class="popup-empty">뜻을 찾지 못했어요.</div>'}
          `;
                }
                reposition();
            }).catch(() => {
                if (popup.isConnected) {
                    body.innerHTML = `<div class="popup-empty">사전을 불러오지 못했어요.</div>`;
                    reposition();
                }
            });
        }
        onWordClick(e) {
            const wordEl = e.target.closest(".word");
            if (!wordEl)
                return;
            e.stopPropagation();
            const word = wordEl.dataset.word || "";
            if (!word)
                return;
            if (this.soundEnabled) {
                this.voiceService.speakWord(word);
            }
            const popup = this.openPopupLoading(wordEl, word);
            if (popup)
                this.fillPopup(popup, wordEl, word);
        }
        onWordKeydown(e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                this.onWordClick(e);
            }
        }
        onPopupClose() {
            this.closePopup();
        }
        onPopupSpeak(e) {
            const popup = e.target.closest(".word-popup");
            const word = popup?.querySelector(".popup-word")?.textContent || "";
            if (word)
                this.voiceService.speakWord(word);
        }
        onSentenceClick(e) {
            // 단어 클릭은 위 핸들러가 처리 (stopPropagation 되지만 delegate 순서 보장용으로 재확인)
            if (e.target.closest(".word"))
                return;
            if (e.target.closest(".word-popup"))
                return;
            const block = e.target.closest(".sentence");
            if (!block)
                return;
            const idx = parseInt(block.dataset.index || "-1", 10);
            if (idx >= 0 && idx !== this.currentActiveIndex) {
                const prev = this.currentActiveIndex;
                this.currentActiveIndex = idx;
                this.currentWordIndex = -1;
                this.currentSelectedWord = "";
                this.updateActiveSentence(prev, idx);
                this.updateToolbar();
            }
            this.speakActiveSentence();
        }
        onReadingClick(e) {
            // 팝업 바깥(여백) 클릭이면 닫기
            if (e.target.closest(".word-popup"))
                return;
            if (e.target.closest(".word"))
                return;
            if (e.target.closest(".sentence"))
                return;
            this.closePopup();
        }
        onBackClick() {
            this.router?.go('/text-english');
        }
        onKoreanToggle() {
            this.showKorean = !this.showKorean;
            this.closePopup();
            this.renderSentences();
            this.updateToolbar();
            this.scrollToActiveItem(false);
        }
        onSoundToggle() {
            this.soundEnabled = !this.soundEnabled;
            if (!this.soundEnabled)
                this.voiceService.stopSpeech();
            this.updateToolbar();
        }
        onPrevClick() {
            this.goSentence(-1);
        }
        onNextClick() {
            this.goSentence(1);
        }
        onPrevWordClick() {
            this.onPrevWord();
        }
        onNextWordClick() {
            this.onNextWord();
        }
        onSpeakClick() {
            this.speakActiveSentence();
        }
        render() {
            return `
        <style>
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
          :host {
            display: block;
            min-height: 100vh;
            background: #faf8f2;
            font-family: Georgia, 'Noto Serif KR', serif;
            color: #2b2b2b;
          }

          .toolbar {
            display: flex; align-items: center; gap: 8px;
            padding: 10px 16px;
            background: linear-gradient(135deg, #0d47a1 0%, #1976d2 60%, #42a5f5 100%);
            color: white;
          }
          .toolbar-back {
            background: rgba(255,255,255,0.2); border: none; color: white;
            width: 36px; height: 36px; border-radius: 8px; cursor: pointer;
            display: flex; align-items: center; justify-content: center; font-size: 18px;
            flex-shrink: 0;
          }
          .toolbar-back:hover { background: rgba(255,255,255,0.3); }
          .toolbar-title {
            font-size: 16px; font-weight: 700; flex: 1; min-width: 0;
            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
            font-family: var(--font-family, sans-serif);
          }
          .progress {
            font-size: 12px; opacity: 0.9; white-space: nowrap;
            font-family: var(--font-family, sans-serif);
          }
          .tool-btn {
            background: rgba(255,255,255,0.2); border: none; color: white;
            min-width: 36px; height: 36px; border-radius: 8px; cursor: pointer;
            font-size: 15px; padding: 0 8px;
            display: flex; align-items: center; justify-content: center; gap: 4px;
            font-family: var(--font-family, sans-serif);
          }
          .tool-btn:hover { background: rgba(255,255,255,0.3); }
          .tool-btn.active { background: #ffca28; color: #4e342e; }
          .reading-wrap {
            padding: 28px 20px 120px;
          }

          .reading {
            position: relative;
            background: #fffdf7;
            border: 1px solid #e8e0d0;
            border-radius: 12px;
            padding: 28px 30px;
            box-shadow: 0 2px 12px rgba(0,0,0,0.05);
          }

          .sentence {
            padding: 10px 12px;
            border-radius: 8px;
            cursor: pointer;
            border-left: 3px solid transparent;
            outline: none;
            /* 화면 밖 문장은 레이아웃/페인트 스킵 — 1443문장 스크롤 최적화 */
            content-visibility: auto;
            contain-intrinsic-size: auto 140px;
          }
          .sentence:hover { background: #f7f2e7; }
          .sentence.active {
            background: #fff8e1;
            border-left-color: #ffca28;
          }
          .sentence .en {
            font-size: 17px;
            line-height: 2.0;
            overflow-wrap: break-word;
            word-break: break-word;
          }
          .sentence .ko {
            font-size: 14px;
            line-height: 1.8;
            color: #6d6d6d;
            margin-top: 6px;
            font-family: var(--font-family, sans-serif);
            overflow-wrap: break-word;
            word-break: break-word;
          }

          .word {
            border-radius: 4px;
            padding: 1px 1px;
            cursor: pointer;
            outline: none;
          }
          .word:hover { background: #ffe082; }
          .word:focus-visible { background: #ffe082; box-shadow: 0 0 0 2px #1976d2; }
          .word.selected { background: #ffca28; }

          .empty { text-align: center; padding: 60px; color: #888; font-family: var(--font-family, sans-serif); }

          /* 단어 툴팁 팝업 */
          .word-popup {
            position: absolute;
            z-index: 100;
            width: 300px;
            max-width: calc(100% - 16px);
            background: #fff;
            border: 1px solid #d7ccc8;
            border-radius: 12px;
            box-shadow: 0 12px 32px rgba(0,0,0,0.22);
            overflow: hidden;
            font-family: var(--font-family, sans-serif);
          }
          .popup-head {
            display: flex; align-items: center; justify-content: space-between;
            padding: 10px 12px;
            background: #4e342e;
            color: #fff;
          }
          .popup-word { font-size: 16px; word-break: break-word; }
          .popup-head-btns { display: flex; gap: 4px; }
          .popup-speak, .popup-close {
            background: rgba(255,255,255,0.15); border: none; color: #fff;
            width: 28px; height: 28px; border-radius: 6px; cursor: pointer; font-size: 13px;
          }
          .popup-speak:hover, .popup-close:hover { background: rgba(255,255,255,0.3); }
          .popup-body {
            padding: 12px;
            max-height: 260px;
            overflow-y: auto;
            font-size: 13px;
            line-height: 1.6;
          }
          .popup-loading, .popup-empty { color: #999; text-align: center; padding: 12px; }
          .phonetic { color: #8d6e63; margin-bottom: 8px; }
          .pos-block { margin-bottom: 8px; }
          .pos-type {
            display: inline-block;
            font-size: 11px; font-weight: 700;
            background: #efebe9; color: #5d4037;
            padding: 1px 8px; border-radius: 999px; margin-bottom: 4px;
          }
          .meaning { margin-bottom: 4px; word-break: break-word; }
          .example-en { color: #444; margin-top: 2px; }
          .example-ko { color: #999; }

          .bottom-nav {
            position: fixed;
            bottom: 0; left: 0; right: 0;
            z-index: 60;
            display: flex; align-items: center; justify-content: center; gap: 10px;
            padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
            background: rgba(255,253,247,0.96);
            border-top: 1px solid #e8e0d0;
            font-family: var(--font-family, sans-serif);
          }
          .nav-btn {
            background: #1976d2; border: none; color: white;
            padding: 10px 18px; border-radius: 10px; cursor: pointer; font-size: 14px;
          }
          .nav-btn:hover { background: #1565c0; }
          .nav-btn.speak { background: #4e342e; }
          .nav-btn.speak:hover { background: #3e2723; }
          .nav-btn.toggle { background: #fff; color: #4e342e; border: 1px solid #d7ccc8; }
          .nav-btn.toggle:hover { background: #efebe9; }
          .nav-btn.toggle.active { background: #ffca28; border-color: #ffca28; color: #4e342e; }
          .nav-btn.word-nav { background: #fff; color: #1976d2; border: 1px solid #90caf9; padding: 10px 12px; }
          .nav-btn.word-nav:hover { background: #e3f2fd; }
          .nav-hint { font-size: 11px; color: #aaa; }

          @media (max-width: 600px) {
            .reading-wrap { padding: 12px 8px 120px; }
            .reading { padding: 16px 14px; }
            .sentence .en { font-size: 16px; }
            .toolbar-title { font-size: 14px; }
            .nav-hint { display: none; }
          }
        </style>

        <div class="toolbar">
          <button class="toolbar-back" aria-label="목록으로" title="목록으로">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
          </button>
          <div class="toolbar-title">📖 Text English</div>
          <div class="progress">0 / 0</div>
        </div>

        <main class="reading-wrap">
          <div class="reading">
            <div class="empty">본문을 불러오는 중...</div>
          </div>
        </main>

        <nav class="bottom-nav">
          <button class="nav-btn toggle btn-korean" title="한글 보기 토글 (T)">🇰🇷</button>
          <button class="nav-btn toggle btn-sound active" title="소리 토글 (M)">🔊</button>
          <button class="nav-btn btn-prev" title="이전 문장 (↑)">←</button>
          <button class="nav-btn word-nav btn-word-prev" title="이전 단어 (←)">◀</button>
          <button class="nav-btn speak btn-speak" title="문장 듣기 (Enter)">🎙️</button>
          <button class="nav-btn word-nav btn-word-next" title="다음 단어 (→)">▶</button>
          <button class="nav-btn btn-next" title="다음 문장 (↓)">→</button>
          <span class="nav-hint">←→ 단어 · ↑↓ 문장 · Enter 듣기 · T 한글 · Esc 닫기</span>
        </nav>
      `;
        }
    };
    __decorate([
        onConnectedBefore,
        innerHtml((c, helper) => helper.$w.document.querySelector("title"), { valueKey: "titleBody" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:title"]'), "content", { valueKey: "ogTitle" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="description"]'), "content", { valueKey: "desc" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:description"]'), "content", { valueKey: "ogDesc" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:image"]'), "content", { valueKey: "ogImage" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:image"]'), "content", { valueKey: "twitterImage" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:title"]'), "content", { valueKey: "twitterTitle" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="twitter:description"]'), "content", { valueKey: "twitterDesc" }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "setPageMeta", null);
    __decorate([
        onInitialize,
        __param(0, Inject(VideoItemService.SYMBOL)),
        __param(1, Inject(TextTranslationService.SYMBOL)),
        __param(2, Inject(DictionaryService.SYMBOL)),
        __param(3, Inject(VoiceService.SYMBOL)),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, Object, Object]),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onInit", null);
    __decorate([
        onConnectedAfter,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof Router !== "undefined" && Router) === "function" ? _a : Object]),
        __metadata("design:returntype", Promise)
    ], TextEnglishReaderPage.prototype, "onConnectedAfter", null);
    __decorate([
        onDisconnected,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onDisconnected", null);
    __decorate([
        innerHtml(".reading"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", String)
    ], TextEnglishReaderPage.prototype, "renderSentences", null);
    __decorate([
        eventDelegate(".word", 'click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Event !== "undefined" && Event) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onWordClick", null);
    __decorate([
        eventDelegate(".word", 'keydown'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof KeyboardEvent !== "undefined" && KeyboardEvent) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onWordKeydown", null);
    __decorate([
        eventDelegate(".popup-close", 'click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onPopupClose", null);
    __decorate([
        eventDelegate(".popup-speak", 'click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof Event !== "undefined" && Event) === "function" ? _d : Object]),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onPopupSpeak", null);
    __decorate([
        eventDelegate(".sentence", 'click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof Event !== "undefined" && Event) === "function" ? _e : Object]),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onSentenceClick", null);
    __decorate([
        event(".reading", "click", { delegate: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof Event !== "undefined" && Event) === "function" ? _f : Object]),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onReadingClick", null);
    __decorate([
        event(".toolbar-back", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onBackClick", null);
    __decorate([
        event(".btn-korean", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onKoreanToggle", null);
    __decorate([
        event(".btn-sound", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onSoundToggle", null);
    __decorate([
        event(".btn-prev", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onPrevClick", null);
    __decorate([
        event(".btn-next", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onNextClick", null);
    __decorate([
        event(".btn-word-prev", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onPrevWordClick", null);
    __decorate([
        event(".btn-word-next", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onNextWordClick", null);
    __decorate([
        event(".btn-speak", "click"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "onSpeakClick", null);
    __decorate([
        onConnectedBodyShadow,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TextEnglishReaderPage.prototype, "render", null);
    TextEnglishReaderPage = __decorate([
        elementDefine(tagName, { window: w })
    ], TextEnglishReaderPage);
    return tagName;
};
